import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/auth";
import {
  BridalHero, BridalIntro, BridalExperience, BridalMenu, BridalExtensions,
  BridalMorning, BridalMobile, BridalGallery, BridalFaq, BridalCta,
} from "@/components/bridal/BridalSections";
import { BridalFormSection } from "@/components/bridal/BridalEnquiryForm";

export default function Bridal() {
  const [c, setC] = useState(null);
  const [images, setImages] = useState([]);
  const formRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    document.title = "Bridal Hair | Bridal by Malek Dridi";
    axios.get(`${API}/bridal/content`).then((r) => setC(r.data)).catch(() => setC(false));
    axios.get(`${API}/bridal/gallery`).then((r) => setImages(r.data?.images || [])).catch(() => {});
  }, []);

  const toForm = () => formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  const toMenu = () => menuRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  if (c === null) {
    return <div className="pt-40 pb-40 flex justify-center text-[#2A1F27]/50"><Loader2 className="animate-spin" size={22} /></div>;
  }
  if (!c) return <div className="pt-40 pb-40 text-center text-sm text-[#2A1F27]/60">Couldn't load this page — please refresh.</div>;

  const items = c.menu?.items || [];
  const firstGroup = items[0]?.group;
  const services = items.filter((m) => (firstGroup ? m.group === firstGroup : !/fee$/i.test(m.name))).map((m) => m.name);

  return (
    <div data-testid="page-bridal" className="bg-[#FAF7F2] text-[#2A1F27] selection:bg-[#D9C79E]/50">
      <BridalHero hero={c.hero} onEnquire={toForm} onMenu={toMenu} />
      <BridalIntro intro={c.intro} />
      <BridalExperience experience={c.experience} />
      <BridalMenu menu={c.menu} onEnquire={toForm} menuRef={menuRef} />
      <BridalExtensions extensions={c.extensions} />
      <BridalMorning morning={c.morning} />
      <BridalMobile mobile={c.mobile} />
      <BridalGallery gallery={c.gallery} images={images} />
      <BridalFaq faqs={c.faqs} />
      <BridalCta cta={c.cta} onEnquire={toForm} />
      <BridalFormSection form={c.form} services={services} formRef={formRef} />
    </div>
  );
}
